import React from "react";
import "./WaveDesign.scss";

function WaveDesign() {
    return (
        <section className={"waveContainer"}>
            <div
                dangerouslySetInnerHTML={{
                    __html:
                        '<svg id="I4525:28198;3:656" layer-name="Wave" width="100%" height="85" viewBox="0 0 3000 85" fill="none" xmlns="http://www.w3.org/2000/svg" class="wave" preserveAspectRatio="none" style="width: 100% !important; height: 85px"><g clip-path="url(#clip0_11097_17335)"> <path d="M-3.71547e-06 85L-5.10272e-09 0.116675C-5.10272e-09 0.116675 429.751 -1.31336 864.582 5.83687C1374.885 14.9279 1698.687 31.6798 2081.268 31.4755C2559.855 31.1691 3000 9.20773 3000 9.20773L3000 85.0001L-3.71547e-06 85Z" fill="#F2F5F6"></path> </g> <defs> <clipPath id="clip0_11097_17335"> <rect width="85.0001" height="3000" fill="white" transform="translate(3000) rotate(90)"></rect> </clipPath> </defs> </svg>',
                }}
            />
        </section>
    );
}

export default WaveDesign;
